import React, { useState } from "react";
import API_BASE_URL from "../apiConfig";

export default function LedgerStatementReport() {
  const [from, setFrom] = useState("2025-04-01");
  const [to, setTo] = useState("2026-03-31");
  const [accountName, setAccountName] = useState("");
  const [rows, setRows] = useState([]);

  const load = async () => {
    const params = new URLSearchParams({ from, to });
    if (accountName) params.append("accountName", accountName);
    const res = await fetch(`${API_BASE_URL}/reports/ledger?${params.toString()}`);
    setRows(await res.json());
  };

  return (
    <div style={{ maxWidth: 1000, margin: "0 auto" }}>
      <div style={{ textAlign: "center", marginBottom: 10 }}>
        <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
        <input type="date" value={to} onChange={(e) => setTo(e.target.value)} style={{ marginLeft: 6 }} />
        <input placeholder="Party / Account" value={accountName} onChange={(e) => setAccountName(e.target.value)} style={{ marginLeft: 6 }} />
        <button onClick={load} style={{ marginLeft: 6 }}>Go..</button>
      </div>
      <h3 style={{ textAlign: "center" }}>Ledger - Statement of Account</h3>
      <table border="1" cellPadding="6" style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr><th>Account</th><th>Date</th><th>Particulars</th><th>Type</th><th>Debit</th><th>Credit</th><th>Balance</th></tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              <td>{r.accountName}</td>
              <td>{r.entryDate?.slice(0, 10)}</td>
              <td>{r.particulars}</td>
              <td>{r.voucherType}</td>
              <td style={{ textAlign: "right" }}>{r.debit ? r.debit.toFixed(2) : ""}</td>
              <td style={{ textAlign: "right" }}>{r.credit ? r.credit.toFixed(2) : ""}</td>
              <td style={{ textAlign: "right" }}>{r.runningBalance.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p style={{ textAlign: "center", fontStyle: "italic", marginTop: 20 }}>*** End of report ***</p>
    </div>
  );
}